module.exports = __webpack_public_path__ + "img/alreadyOpening.cbcae1dd.png";